import React from 'react'
import {
    FormControl, InputLabel, Select, MenuItem, Grid, TextField, Box, Button,
    Typography, Container, OutlinedInput, InputAdornment, Tooltip, Link,
    Checkbox, FormControlLabel, IconButton, Input, Paper
} from '@mui/material';
import { Chip } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import axiosInstance from '../../lib/axios';
import Flag from '../../Components/Ragistration/Booking/Flag';
import moment from 'moment';
import BokingCModal from '../../Components/Ragistration/BConfirmation/BokingCModal';
import AccountGModal from '../../Components/Ragistration/BConfirmation/AccountGModal';
import { useReactToPrint } from 'react-to-print';
import axiosInstanceForPG from '../../lib/axiosFormPG';
import CircularProgress from '@mui/material/CircularProgress';
import 'jspdf-autotable';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ConfirmationDialog from '../ReusableDailog';
import EmailIcon from '@mui/icons-material/Email';
import { useSelector } from 'react-redux';
import { selectGlobalProperty, selectGatewayType } from '../../redux/propertySlice';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import PrintIcon from '@mui/icons-material/Print';
// import CheckoutRequestReport from './CheckoutRequestReport';

const columns = [
    { id: 'BookId', label: 'BookId', minWidth: 50 },
    { id: 'BookNo', label: 'Booking No', minWidth: 120 },
    { id: 'BookDt', label: 'Book Date', minWidth: 130 },
    { id: 'BookSt', label: 'Status', minWidth: 130 },
    { id: 'FirstName', label: 'Resident', minWidth: 130 },
    { id: 'MobileNo', label: 'Mobile', minWidth: 150 },
    { id: 'Duration', label: 'Duration', minWidth: 100 },
    { id: 'CheckinDt', label: 'CheckIn', minWidth: 100 },
    { id: 'CheckoutDt', label: 'CheckOut', minWidth: 100 },
];

function CheckoutApprovel(bookSt, onConfirm, bookId, onAccDetails, onAccGenerate) {
    const { register, watch, setValue, reset } = useForm();
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [OpenLoader, setOpenLoader] = useState(false);
    const [TransactionData, setTransactionData] = useState([]);
    const [OpenHistoryTableDialog, setOpenHistoryTableDialog] = useState(false);
    const [AccGenerate, setAccGenerate] = useState(false);
    const [BookId, setBookId] = useState(-1);
    const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(8);
    const [searchTerms, setSearchTerms] = useState({});
    const [activeView, setActiveView] = useState('advice');
    const [Mode, setMode] = useState('add');
    const [loadingPaymentLinks, setLoadingPaymentLinks] = useState({});
    const location = useLocation();
    const contentRef = useRef(null);
    const [hasUnpaidRent, setHasUnpaidRent] = useState(false);
    const [switchState, setSwitchState] = useState(false);
    const [emailResponse, setEmailResponse] = useState(null);
    const [isBookingConfirmed, setIsBookingConfirmed] = useState(false);
    const [openCheckoutConfirm, setOpenCheckoutConfirm] = useState(false);
    const [chkReqId, setChkReqId] = useState(null);
    const handlePrint = useReactToPrint({ contentRef });
    const globalProperty = useSelector(selectGlobalProperty);
    const [showPayAdvice, setShowPayAdvice] = useState(false);
    const baseUrl = window.location.origin;
    const [payAdvice, setPayAdvice] = useState([]);
    const [isCheckoutProcessing, setIsCheckoutProcessing] = useState(false);
    const [selectedCheckoutDate, setSelectedCheckoutDate] = useState(new Date().toLocaleDateString('en-GB'));
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [accountData, setAccountData] = useState([]);
    const [oldBedId, setOldBedId] = useState('');
    const [residentid, setResidentId] = useState(null);
    const [propId, setPropId] = useState(null);
    const [selectedData, setSelectedDate] = useState(new Date().toLocaleDateString('en-GB'));
    const [minCheckInDate, setMinCheckInDate] = useState(null);
    const [checkoutRequestData, setCheckoutRequestData] = useState(null);
    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
    const gatewayType = useSelector(selectGatewayType);

    const sendCheckoutRequestEmail = async () => {
        try {
            setIsLoading(true);
            const userId = parseInt(sessionStorage.getItem('UserId'));
            const requestCheckoutDate = watch('ReqCheckoutDt');
            const expectedCheckoutDate = watch('expectedcheckout');
            const reason = watch('Resion') || 'Not specified';
            const residentName = watch('ResidentName');
            const propertyName = watch('PropName');
            const bookingNo = watch('BookNo');
            const email = watch('Email');

            const formData = {
                bookingNo,
                // residentId,
                residentName,
                propertyName,
                requestCheckoutDate,
                expectedCheckoutDate,
                reason,
                bookId
            };
            const encodedData = encodeURIComponent(JSON.stringify(formData));
            const baseUrl = window.location.origin;
            const formLink = `${baseUrl}/bank-info?data=${encodedData}`;
            const subject = `Clanbridge Living -  Check-out Request Approved [Booking: ${bookingNo}]`;

            const Body = `Hey <strong>${residentName}</strong>,<br><br>
We are pleased to inform you that your check-out request has been <strong>APPROVED</strong> for your tenancy at <strong>${propertyName}</strong>.<br><br>
Following are the approved check-out details:<br><br>
Booking No: <strong>${bookingNo}</strong><br>
Resident Name: <strong>${residentName}</strong><br>
Property: <strong>${propertyName}</strong><br>
Request Date: <strong>${requestCheckoutDate}</strong><br>
Approved Check-out Date: <strong>${expectedCheckoutDate}</strong><br>
Reason: <strong>${reason}</strong><br><br>
<a href="${formLink}" target="_blank" style="background-color: #635bff; color: white; padding: 6px 15px; text-decoration: none; border-radius: 5px; display: inline-block; margin-top: 10px;">Submit Bank Details</a><br><br>
Your check-out has been scheduled as requested. Please ensure the following before your check-out date:<br>
1. Clear all pending dues<br>
2. Return all property keys and access cards<br>
3. Complete the room inspection with our team<br>
4. Collect your security deposit refund (if applicable)<br><br>
Our team will contact you shortly to coordinate the check-out process and schedule the final room inspection.<br><br>
If you have any questions or need to make changes, please contact our support team at <strong>sales@clanbridge.com</strong> or reach out to your Resident Captains.<br><br>
We hope you had a pleasant stay with us and wish you all the best for your future endeavors!<br><br>
Cheers,<br>
Team Clanbridge`;

            const emailRequest = {
                ToEmail: email ? [email] : [],
                Subject: subject,
                Body: Body,
                Attachments: '',
                attachmentFilePaths: [],
                PropId: watch('PropId') || globalProperty,
                UserId: userId,
            };

            const emailResponse = await axiosInstanceForPG.post(
                `EmailRequest/SendEmail`,
                emailRequest,
            );

            if (emailResponse.data.Status === 0) {
                toast.success(`Check-out Approved email sent successfully`);
            } else {
                toast.info(emailResponse.data.Message || "Failed to send email");
            }

            return emailResponse.data.Status === 0;
        } catch (error) {
            console.error('Error sending email:', error);
            toast.error("Failed to send check-out request email");
            return false;
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (BookId !== -1 && !isCheckoutProcessing) {
            fetchPayAdvice(BookId);
        }
    }, [BookId, isCheckoutProcessing]);

    useEffect(() => {
        let ChkReqId = location.state?.ChkReqId;
        console.log('ChkReqId', ChkReqId)
        let BookId = location?.state?.BookId
        if (BookId) {
            fetchTransactionData(BookId);
        } else {
            setMode("add");
        }
        const fetchApi = async () => {
            setValue("CountryIcon", Flag);
            setValue("BookDt", "");
            setValue("BookDtFrom", "");
            setValue("BookUpToDt", "");
            if (ChkReqId) {
                await fetchCheckoutRequest(ChkReqId);
            }

        };
        fetchApi();
    }, [location.state?.BookId, location?.state?.ChkReqId]);

    const fetchCheckoutRequest = async (ChkReqId) => {
        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/RetrivetrnChkReq`, {
                ChkReqId: ChkReqId,
                Flag: "R",
            });

            if (response.data.Status === 0) {
                const requestData = response.data.Data[0];
                setCheckoutRequestData(requestData);
                setValue('ReqCheckoutDt', moment(requestData.CheReqDt).format('DD/MM/YYYY'));
                setValue('expectedcheckout', moment(requestData.ExpCheOutDt).format('DD/MM/YYYY'));
                setValue('Resion', requestData.Reason || '');
                if (requestData.BookId) {
                    await fetchTransactionData(requestData.BookId);
                }
            }
        } catch (error) {
            toast.error("Failed to load checkout request data");
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchTransactionData = async (bookId) => {
        if (!bookId) return;

        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/RetriveTrnBooking`, {
                BookId: bookId,
                Flag: "R",
                CreatedBy: UserId
            }
            );

            if (response.data.Status === 0) {
                setIsDataLoaded(true);
                const bookingData = response.data.Data[0];
                const {
                    BookSt, PropId, ResidentId, RoomBedId, CheckedOutDt, MobileNo, ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, CheckoutDt,
                    TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, CheckinDt, CheckingDt, Email, PlanName, MonthlyAmt, BookStatus
                } = bookingData;
                setAccountData(bookingData);
                setOldBedId(RoomBedId);
                setResidentId(ResidentId);
                setPropId(PropId);
                setBookId(bookId);
                setValue("MobileNo", MobileNo);
                setValue("ResidentName", ResidentName);
                setValue("BookNo", BookNo);
                setValue("BookDt", BookDt);
                setValue("Duration", Duration);
                setValue("BookDtFrom", BookDtFrom);
                setValue("BookUpToDt", BookUpToDt);
                setValue("CheckoutDt", CheckoutDt);
                setValue("TopupAmt", TopupAmt);
                setValue("AdvcRcble", AdvcRcble);
                setValue("DiscAmt", DiscAmt);
                setValue("TotalRent", TotalRent);
                setValue("NetAmt", NetAmt);
                setValue("BedRent", BedRent);
                setValue("FreeMonth", FreeMonth);
                setValue("PropName", PropName);
                setValue("Email", Email);
                setValue("PlanName", PlanName);
                setValue("MonthlyAmt", MonthlyAmt);
                setValue("CheckinDt", CheckinDt)
                setValue('CheckedOutDt', CheckedOutDt)
                setValue('CheckingDt', CheckingDt)
                if (BookSt === "C") {
                    setSelectedDate(CheckinDt);
                } else {
                    const currentDate = new Date().toISOString()?.split("T")[0];
                    const bookFromDateObj = new Date(BookDtFrom);
                    const currentDateObj = new Date(currentDate);
                    bookFromDateObj.setHours(0, 0, 0, 0);
                    currentDateObj.setHours(0, 0, 0, 0);
                    setSelectedDate(currentDateObj >= bookFromDateObj ? currentDate : BookDtFrom);
                }

                setMinCheckInDate(BookDtFrom);
                setAccGenerate(BookSt === "B");
                setTransactionData(response.data.Data);
                await fetchPayAdvice(bookId);
                await fetchRoomBedData(RoomBedId, BookDtFrom, BookUpToDt, PropId);
                await fetchServicesData(bookingData.TransPlanId, bookingData.MessPlanId);
            } else {
                setIsDataLoaded(false);
                toast.info("Booking Not Found");
                resetFuncM();
            }
        } catch (error) {
            toast.error("Failed to load booking data");
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchPayAdvice = async (BookId) => {
        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                "PytAdvDt": moment().format("YYYY-MM-DD"),
                "Flag": "GenPytAdv",
                "BookId": BookId
            });

            if (response.data.Status === 0) {
                setPayAdvice(response.data.Data);
                setShowPayAdvice(true);

                const unpaidRentExists = response.data.Data.some(
                    item => item.PytAdvFor === "R" && item.IsDepPaid !== "Y"
                );
                const firstInstallmentPaid = response.data.Data.some(
                    item => item.PytAdvFor === "R" &&
                        item.Remark?.includes("Installment 1") &&
                        item.IsDepPaid === "Y"
                );

                setHasUnpaidRent(unpaidRentExists && !firstInstallmentPaid);
            }
        } catch (error) {
            toast.error('Error fetching payment advice:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    useEffect(() => {
        if (TransactionData.length > 0) {
            const { MobileNo, ResidentName, ResidentId, ChkReqId, CheckinDt, BookNo, CheckingDt, BillCycle, CheckoutDt, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, BookId, PropName, Email, PropId } = TransactionData[0];
            let obj = { ResidentName, ResidentId, BookNo, BookDt, Duration, BillCycle, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, MobileNo, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, Email, CheckinDt, PropId }

            setValue("MonthlyAmt", Math.round(NetAmt / Duration));
            setObjValue(obj);
            setValue("Email", Email);
            setValue("PropId", PropId);
            setValue("ResidentId", ResidentId)
            setValue("CheckinDt", CheckinDt)
            setValue("BillCycle", BillCycle)
            setValue('CheckingDt', CheckingDt)
            setBookId(BookId)
            const fetchDataAndSet = async () => {
                await fetchRoomBedData(TransactionData[0].RoomBedId, TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, TransactionData[0].PropId);
                await fetchPlanData(TransactionData[0].RoomPlanId);
                await fetchServicesData(TransactionData[0].TransPlanId, TransactionData[0].MessPlanId);
            }
            fetchDataAndSet();
            setNetAmount();
        }
    }, [TransactionData, globalProperty]);

    useEffect(() => {
        const today = dayjs();
        const formattedToday = today.format('DD/MM/YYYY');
        setValue('CheckoutDt', formattedToday);
        setSelectedCheckoutDate(formattedToday);
    }, []);

    const handleSearchChange = (columnId, value) => {
        setSearchTerms(prev => ({ ...prev, [columnId]: value }));
        setPage(0);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const filteredRows = React.useMemo(() => {
        return rows.filter(row => {
            return Object.entries(searchTerms).every(([columnId, term]) => {
                if (!term) return true;
                const value = row[columnId];
                if (typeof value === 'string') {
                    return value.toLowerCase().includes(term.toLowerCase());
                } else if (typeof value === 'number') {
                    return value.toString().includes(term);
                }
                return true;
            });
        });
    }, [searchTerms, rows]);

    const handleMobileChange = async (e, Separator) => {
        let val = "";
        if (Separator === "A") {
            val = e.target.value.trim()
        } else {
            val = e.trim();
        }

        if (val.length >= 10) {
            try {
                const response = await axiosInstance.post(
                    `TrnBooking/GetTrnBookingDashBoard`,
                    {
                        "start": 1,
                        "PageSize": 1,
                        "SearchText": '',
                        "Flag": '',
                        "MobileNo": val,
                        "BookNo": '',
                        "PropId": 1,
                    }
                );

                if (response.data.Status === 0) {
                    setIsDataLoaded(true);
                    const { BookSt, IsDepPaid, ChkReqId } = response.data.Data[0];
                    setChkReqId(ChkReqId);
                    const data = response.data.Data[0]
                    setAccountData(data);
                    setIsBookingConfirmed(BookSt === "O");
                    setSwitchState(BookSt === "O");
                    if (BookSt === "B") {
                        setAccGenerate(false);
                    } else {
                        setAccGenerate(true);
                    }
                    setTransactionData(response.data.Data);
                    await fetchPayAdvice(response.data.Data[0].BookId);
                } else {
                    setIsDataLoaded(false);
                    toast.info("Booking Doesn't Exist On This Number");
                    resetFuncM();
                    setValue("BookNo", "");
                    setBookId(-1);
                    setChkReqId(null);
                }
            } catch (error) {
                toast.error('Error fetching data:', error);
            }
        } else if (val.length === 9) {
            resetFuncM();
            setValue("BookNo", "");
            setBookId(-1);
        }
        Separator === "B" && handleClose();
    };

    const handleBookNoChange = async (e, Separator) => {
        let val = "";
        if (Separator === "A") {
            val = e.target.value.trim()
        } else {
            val = e.trim();
        }

        if (val.length >= 8) {
            try {
                const response = await axiosInstance.post(
                    `TrnBooking/GetTrnBookingDashBoard`,
                    {
                        "start": 1,
                        "PageSize": 1,
                        "SearchText": '',
                        "Flag": '',
                        "MobileNo": '',
                        "BookNo": val,
                        "PropId": 1,
                    }
                );

                if (response.data.Status === 0) {
                    setIsDataLoaded(true);
                    const { BookSt, IsDepPaid, ChkReqId } = response.data.Data[0];
                    setChkReqId(ChkReqId);
                    setChkReqId(ChkReqId);
                    setIsBookingConfirmed(BookSt === "O");
                    setSwitchState(BookSt === "O");

                    if (BookSt === "B") {
                        setAccGenerate(true);

                    } else {
                        setAccGenerate(false);
                    }
                    setTransactionData(response.data.Data);
                    await fetchPayAdvice(response.data.Data[0].BookId);
                } else {
                    toast.info("Booking Doesn't Exist On This Number");
                    resetFuncM();
                    setValue("MobileNo", "");
                    setBookId(-1);
                    setChkReqId(null);
                    setChkReqId(null);
                }
            } catch (error) {
                toast.error('Error fetching Booking data:', error);
            }
        } else if (val.length === 7) {
            setIsDataLoaded(false);
            resetFuncM();
            setValue("MobileNo", "");
        }
        Separator === "B" && handleClose();
    }

    const fetchRoomBedData = async (RoomBedId, date1, date2, PropId) => {
        try {
            const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
                BookFromDt: date1,
                BookToDt: date2,
                PropId: PropId,
                Flag: "",
                RoomBedId: RoomBedId
            });

            if (response.data.Status === 0) {
                handleRowDoubleClick(response.data.Data[0]);
            }
        } catch (error) {
            toast.error('Error fetching company data:', error);
        }
    };

    const fetchPlanData = async (PlanId) => {
        try {
            const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
                "RoomPlanID": PlanId,
                "Flag": "R"
            });

            if (response.data.Status === 0) {
                setPlanData(response.data.Data);
            }
        } catch (error) {
            toast.error('Error fetching company data:', error);
        }
    };

    const handleRowDoubleClick = async (row) => {
        const { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, } = row;
        const obj = { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, };
        setObjValue(obj);
    };

    const setPlanData = (PlanArr) => {
        const { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt } = PlanArr[0];
        const obj = { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt };
        setObjValue(obj);
    }


    const setObjValue = (obj) => {
        for (let key in obj) {
            setValue(key, obj[key]);
        }
    }

    const handleClose = () => {
        setOpenHistoryTableDialog(false);
        setPage(0);
        setTimeout(() => {
            setSearchTerms({});
        }, [500]);

    };

    const setNetAmount = () => {
        setValue("TotalAmt", ((watch("TAmount") || 0) + (watch("MAmount") || 0) + (watch("TopupAmt") || 0) + (watch("AdvcRcble") || 0)));
    };

    const fetchServicesData = async (TransPlanId, MessPlanId) => {
        const Flag = "";
        try {
            const response = await axiosInstance.post(
                `MstTransPlan/getMstTransPlandrp`,
                { Flag, UserId },
            );

            if (response.data.Status === 0) {
                // setTransPlanDrp(response.data.Data);
                let obj = response.data.Data.find(obj => obj.TransPlanID === TransPlanId);
                if (obj) {
                    setValue("TAmount", obj.Amount);
                } else {
                    setValue("TAmount", 0);
                }
                setNetAmount()
            } else {
                toast.error('Error fetching Trans data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
        try {
            const response = await axiosInstance.post(
                `MstMessPlan/getMstMessPlandrp`,
                { Flag, UserId },
            );

            if (response.data.Status === 0) {

                let obj = response.data.Data.find(obj => obj.MessPlanID === MessPlanId);
                if (obj) {
                    setValue("MAmount", obj.Amount);
                } else {
                    setValue("MAmount", 0);
                }
                setNetAmount();
            } else {
            }
        } catch (error) {
            toast.error('Error fetching Plan data');
        }
    }
    const resetFuncM = () => {
        const obj = {
            "ResidentName": "",
            "BookDt": "",
            "Duration": "",
            "BookDtFrom": "",
            "BookUpToDt": "",
            "WingName": "",
            "FloorName": "",
            "RoomTypeName": "",
            "RoombedName": "",
            "RoomBedTypeName": "",
            "BedRent": "",
            "PlanName": "",
            "PlanTenur": "",
            "FreeMonth": "0",
            "LastAdjMonths": "0",
            "IncRentPerc": "",
            "DepositAmt": "",
            "TopupAmt": "",
            "Tamt": "",
            "MAmount": "",
            "TAmount": "",
            "TotalRent": "",
            "DiscAmt": "",
            "NetAmt": "",
            "MonthlyAmt": "",
            "PropName": "",
        }
        for (let key in obj) {
            setValue(key, "")
        }
        setValue("CountryIcon", Flag);
        setChkReqId(null);
    };

    const handleCheckoutConfirm = async () => {
        await sendCheckoutRequestEmail()
        setOpenCheckoutConfirm(false)

    };

    const handleClickCancel = () => {
        navigate("/checkout/checkoutaprvtable");
    }

    const formatDate = (date) => {
        if (!date || !moment(date).isValid()) return '';
        return moment(date).format('DD/MM/YYYY');
    };


    const handleSendPaymentLink = async (item) => {
        try {
            setIsLoading(true);
            setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: true }));
            const userId = parseInt(sessionStorage.getItem('UserId'));
            const baseUrl = window.location.origin;

            // const gatewayType = gatewayType || 'CashFree';
            let paymentResponse = null;

            if (gatewayType === 'CashFree') {
                const paymentDetails = {
                    customer_details: {
                        customer_email: item.Email || "",
                        customer_name: item.ResidentName,
                        customer_phone: item.MobileNo
                    },
                    link_amount: item.Amount || 0,
                    link_auto_reminders: true,
                    link_currency: "INR",
                    link_expiry_time: "2026-06-09T15:04:05+05:30",
                    link_id: "Testing9062026",
                    link_meta: {
                        notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                        return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                        upi_intent: false
                    },
                    link_minimum_partial_amount: parseFloat(item.Amount),
                    link_notes: {
                        key_1: "CashFreepay",
                        key_2: "linkCashfree"
                    },
                    link_notify: {
                        send_email: true,
                        send_sms: true
                    },
                    link_partial_payments: true,
                    link_purpose: item.Remark,
                    ResidentId: item.ResidentId,
                    Flag: "Active",
                    Remark: "Testing",
                    TrjType: "TrnPytAdv",
                    TrjDocNo: item.PytAdvNo,
                    TrjDocId: item.BookId,
                    cf_payment_id: "",
                    payment_status: "",
                    PropId: item.PropId
                };

                const response = await axiosInstanceForPG.post(
                    `PaymentGatewayLog/CreateCashFreeLink`,
                    paymentDetails,
                );

                if (response.data.Status == 0) {
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return toast.success(response.data.Message);
                }
                if (response.data.Status == 1) {
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return toast.error(response.data.Message);
                }

                paymentResponse = response.data;
                if (typeof paymentResponse === 'string') {
                    paymentResponse = JSON.parse(paymentResponse);
                }

                if (!paymentResponse || !paymentResponse.link_url) {
                    console.error("Invalid payment response:", paymentResponse);
                    toast.error("Failed to create payment link");
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return;
                }

            } else if (gatewayType === 'Instamojo') {
                const paymentDetails = {
                    purpose: item.Remark || `Payment Advice ${item.PytAdvNo}`,
                    amount: item.Amount || 0,
                    buyer_name: item.ResidentName || '',
                    email: item.Email || '',
                    phone: item.MobileNo || '',
                    redirect_url: `${baseUrl}/payment-success`,
                    redirecturl: `${baseUrl}/payment-success/`,
                    webhook_url: '',
                    ResidentId: item.ResidentId,
                    TrjDocId: item.PytAdvId || 0,
                    TrjType: "TrnPytAdv",
                    TrjDocNo: item.PytAdvNo || '',
                    PropId: item.PropId || 0,
                };

                const response = await axiosInstanceForPG.post(
                    `Payment/CreatePaymentOrder`,
                    paymentDetails,
                );
                if (response.data.Status == 1) {
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return toast.error(response.data.Message);
                }

                if (response.data.Status === 0) {
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return toast.success(response.data.Message);
                }

                paymentResponse = JSON.parse(response.data);

                if (!paymentResponse || !paymentResponse.payment_request || !paymentResponse.payment_request.longurl) {
                    console.error("Invalid payment response:", paymentResponse);
                    toast.error("Failed to create payment link");
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return;
                }

            } else {
                toast.error(`Unsupported gateway type: ${gatewayType}`);
                setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                setIsLoading(false);
                return;
            }


            const paymentToken = gatewayType === 'CashFree' ? paymentResponse.link_id : paymentResponse.payment_request.id;
            const paymentUrl = gatewayType === 'CashFree' ? paymentResponse.link_url : paymentResponse.payment_request.longurl;
            setEmailResponse(paymentUrl);
            const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;

            let paymentLogPayload;
            if (gatewayType === 'CashFree') {
                paymentLogPayload = {
                    id: paymentResponse.link_id,
                    cf_link_id: paymentResponse.cf_link_id,
                    phone: paymentResponse.customer_details.customer_phone,
                    email: paymentResponse.customer_details.customer_email,
                    buyer_name: paymentResponse.customer_details.customer_name || 'null',
                    amount: paymentResponse.link_amount,
                    purpose: paymentResponse.link_purpose,
                    expires_at: null,
                    status: paymentResponse.link_status,
                    send_sms: paymentResponse.link_notify.send_sms,
                    send_email: paymentResponse.link_notify.send_email,
                    sms_status: 'null',
                    email_status: 'null',
                    shorturl: 'null',
                    longurl: paymentResponse.link_url,
                    redirect_url: paymentResponse.link_meta.return_url,
                    webhook: 'null',
                    allow_repeated_payments: true,
                    created_at: paymentResponse.link_created_at,
                    modified_at: paymentResponse.link_created_at,
                    ResidentId: item.ResidentId,
                    link_qrcode: paymentResponse.link_qrcode,
                    TrjDocNo: item.PytAdvNo,
                    TrjDocId: item.PytAdvId,
                    TrjType: "TrnPytAdv",
                    Flag: "Active",
                    Remark: "Payment Link for Payment Advice",
                    Gatewaytype: "CashFree",
                };
            } else {
                paymentLogPayload = {
                    id: paymentResponse.payment_request.id,
                    phone: paymentResponse.payment_request.phone,
                    email: paymentResponse.payment_request.email,
                    buyer_name: paymentResponse.payment_request.buyer_name,
                    amount: paymentResponse.payment_request.amount,
                    purpose: paymentResponse.payment_request.purpose,
                    expires_at: paymentResponse.payment_request.expires_at,
                    status: paymentResponse.payment_request.status,
                    send_sms: paymentResponse.payment_request.send_sms,
                    send_email: paymentResponse.payment_request.send_email,
                    sms_status: paymentResponse.payment_request.sms_status,
                    email_status: paymentResponse.payment_request.email_status,
                    shorturl: paymentResponse.payment_request.shorturl,
                    longurl: paymentResponse.payment_request.longurl,
                    redirect_url: paymentResponse.payment_request.redirect_url,
                    webhook: paymentResponse.payment_request.webhook,
                    allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
                    created_at: paymentResponse.payment_request.created_at,
                    modified_at: paymentResponse.payment_request.modified_at,
                    ResidentId: item.ResidentId,
                    TrjDocNo: item.PytAdvNo,
                    TrjDocId: item.PytAdvId,
                    TrjType: "TrnPytAdv",
                    Flag: "Active",
                    Remark: "Payment Link for Payment Advice",
                    Gatewaytype: "Instamojo",
                };
            }

            await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog', paymentLogPayload);

            const Subject = `Clanbridge Living - Payment Request For Payment Advice No. [${item.PytAdvNo}]`;
            const Body = `Hey <strong>${item.ResidentName}</strong>,<br><br>
        We would like to inform you that payment advice has been created for you tenancy at <strong>${item.PropName}</strong>.Please find attached your payment advice with this email <br><br>
        Following are the details : <br><br>
        Advice No: <strong>${item.PytAdvNo}</strong><br>
        Amount: <strong>${item.Amount}</strong><br>
        Date Of Issue: <strong>${formatDate(item.PytAdvDt)}</strong><br>
        Due Date: <strong>${formatDate(item.DueDt)}</strong><br>
        <strong>Payment Link:</strong> <a href="${intermediatePageUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
        We hope you are having a pleasant stay with us. Do let us know if you need any assitance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
        Cheers,<br>
        Team Clanbridge`;

            const emailRequest = {
                ToEmail: item.Email ? [item.Email] : [],
                Subject,
                Body,
                Attachments: '',
                attachmentFilePaths: [],
                PropId: item.PropId,
                UserId: userId,
            };

            const emailResponse = await axiosInstanceForPG.post(
                `EmailRequest/SendEmail`,
                emailRequest,
            );

            if (emailResponse.data.Status === 0) {
                toast.success(`Payment Link Sent Successfully for ${item.PytAdvNo}`);
            } else {
                toast.info(emailResponse.data.Message);
            }

            fetchPayAdvice(activeView === 'advice' ? 'GenPytAdv' : 'BookingWise');

        } catch (error) {
            console.error('Error sending payment link:', error);
            toast.error(error.response?.data?.Message || "Failed to send payment link");
        } finally {
            setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
            setIsLoading(false);
        }
    };

    const handleSubmit = async () => {
        if (!BookId || BookId === -1) {
            toast.error("Please select a valid booking first");
            return;
        }

        if (!watch('ReqCheckoutDt')) {
            toast.error("Request date is required");
            return;
        }

        if (!watch('expectedcheckout')) {
            toast.error("Expected checkout date is required");
            return;
        }

        let approveStatus = checkoutRequestData.AprvSt === "N" ? "Y" : "N"
        let actionMessage = checkoutRequestData?.AprvSt === "Y"
            ? "Checkout approval has been Cancelled"
            : "Checkout request has been Approved";

        try {
            setOpenLoader(true);
            const payload = [
                {
                    ChkReqId: chkReqId || checkoutRequestData?.ChkReqId || 0,
                    BookId: BookId,
                    AprvBy: parseInt(UserId),
                    AprvRemk: watch('Resion') || "Request for check-out Approved",
                    UpdatedBy: parseInt(UserId),
                    AprvSt: approveStatus
                }
            ]

            const response = await axiosInstance.post(`TrnBooking/UpdateApporvedTrnChkReq`, payload);

            if (response.data.Status === 0) {
                toast.success(actionMessage)
                // setOpenCheckoutConfirm(true)
                if (chkReqId || checkoutRequestData?.ChkReqId) {
                    await fetchCheckoutRequest(chkReqId || checkoutRequestData.ChkReqId);
                }
            } else {
                toast.error(response.data.Message || "Operation failed");
            }
        } catch (error) {
            toast.error("Failed to submit check-out request");
            console.error("Submit error:", error);
        } finally {
            setOpenLoader(false);
        }
    };

    const handleDelete = async () => {
        if (!checkoutRequestData?.ChkReqId) return;

        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(
                `TrnBooking/DeleteTrnChkReq`,
                {
                    "ChkReqId": checkoutRequestData.ChkReqId
                }
            );

            if (response.data.Status === 0) {
                toast.success(response.data.Message);
                setValue('ReqCheckoutDt', dayjs().format('DD/MM/YYYY'));
                setValue('expectedcheckout', dayjs().format('DD/MM/YYYY'));
                setValue('Resion', '');
                setCheckoutRequestData(null);
            } else {
                toast.error(response.data.Message || "Failed to delete check-out request");
            }
        } catch (error) {
            toast.error("Failed to delete check-out request");
        } finally {
            setOpenLoader(false);
            setOpenDeleteConfirm(false);
        }
    };


    return (
        <>
            <Box className="form-container">
                <ToastContainer />
                <BokingCModal OpenHistoryTableDialog={OpenHistoryTableDialog} handleClose={handleClose} columns={columns} TextField={TextField} handleSearchChange={handleSearchChange} filteredRows={filteredRows} page={page} rowsPerPage={rowsPerPage} handleMobileChange={handleMobileChange} handleBookNoChange={handleBookNoChange} handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} />
                <Grid container spacing={3} className="rasidant_grid" >
                    <Container maxWidth="lg" spacing={1} justifyContent="center" alignItems="center">
                        <Box sx={{
                            position: 'relative', display: 'flex', justifyContent: {
                                xs: 'space-between',
                                sm: 'center',
                            },
                            alignItems: 'center', pb: 1
                        }}>
                            <Typography variant="h5" align="center" sx={{
                                fontSize: {
                                    xs: '1.2rem',
                                    sm: '1.5rem',
                                },
                                fontWeight: 500
                            }}
                            >
                                Check-Out Request Approval
                            </Typography>

                            <Box sx={{ position: 'absolute', right: 0, display: 'flex', gap: 1.5, alignItems: 'center' }}>
                                <Tooltip title="Print Report">
                                    <IconButton
                                        onClick={handlePrint}
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            backgroundColor: '#635bff',
                                            color: 'white',
                                            borderRadius: '7px',
                                            padding: '3px 8px',
                                            '&:hover': {
                                                backgroundColor: '#1565c0',
                                            }
                                        }}
                                    >
                                        <PrintIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Send Check-out Approval Email">
                                    <IconButton
                                        onClick={sendCheckoutRequestEmail}
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            backgroundColor: '#635bff',
                                            color: 'white',
                                            borderRadius: '7px',
                                            padding: '3px 8px',
                                            '&:hover': {
                                                backgroundColor: '#1565c0',
                                            }
                                        }}
                                        disabled={isLoading || (!checkoutRequestData?.ChkReqId && !BookId)}
                                    >
                                        {isLoading ? <CircularProgress size={20} /> : <EmailIcon />}
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Exit" arrow>
                                    <IconButton
                                        onClick={handleClickCancel}
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            backgroundColor: '#635bff',
                                            color: 'white',
                                            borderRadius: '7px',
                                            padding: '3px 8px',
                                            '&:hover': {
                                                backgroundColor: '#1565c0',
                                            }
                                        }}
                                    >
                                        <CancelPresentationIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title='Submit document' arrow>
                                    <span>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            sx={{
                                                backgroundColor: checkoutRequestData?.AprvSt === "Y" ? '#ff4444' : '#635BFF',
                                                marginX: 0.2,
                                                '&:hover': {
                                                    backgroundColor: checkoutRequestData?.AprvSt === "Y" ? '#cc0000' : '#5046e5'
                                                }
                                            }}
                                            onClick={handleSubmit}
                                        >
                                            {checkoutRequestData?.AprvSt === "Y" ? "Cancel Approval" : "Approval"}
                                        </Button>
                                    </span>
                                </Tooltip>
                            </Box>
                        </Box>
                        <Grid container md={12} spacing={0.5}>
                            <Grid item xs={12} md={3}>
                                <FormControl variant="outlined" fullWidth>
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <div
                                                    style={{
                                                        width: 25,
                                                        height: 15,
                                                        backgroundImage: `url(${watch("CountryIcon")})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        borderRadius: '4px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                />
                                            </InputAdornment>
                                        }
                                        aria-describedby="outlined-weight-helper-text"
                                        placeholder={`Enter Valid  Mobile Number`}
                                        style={{ width: "100%", height: 40 }}

                                        value={watch('MobileNo') || ''}
                                        {...register('MobileNo', { onChange: (e) => handleMobileChange(e, 'A') })}
                                        inputProps={{
                                            'aria-label': 'weight',
                                            style: { height: 40 },
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="PropName"
                                    name="PropName"
                                    label="Property Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('PropName') || ''}
                                    {...register('PropName')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="ResidentName"
                                    name="ResidentName"
                                    label="First Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('ResidentName') || ''}
                                    {...register('ResidentName')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>

                            {/* <Grid item xs={12} md={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={
                                            <>
                                                Actual CheckOut <span style={{ color: 'red' }}>*</span>
                                            </>
                                        }
                                        value={
                                            watch('CheckingDt')
                                                ? dayjs(watch('CheckingDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])
                                                : dayjs()
                                        }
                                        onChange={(newValue) => {
                                            if (newValue) {
                                                const formattedDate = newValue.format('DD/MM/YYYY');
                                                setValue('CheckingDt', formattedDate);
                                                setSelectedCheckoutDate(formattedDate);
                                            } else {
                                                setValue('CheckingDt', '');
                                                setSelectedCheckoutDate('');
                                            }
                                        }}
                                        minDate={dayjs(watch('CheckinDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])}
                                        disabled={true}
                                        format="DD/MM/YYYY"
                                        slotProps={{
                                            textField: {
                                                variant: 'filled',
                                                fullWidth: true,
                                                className: 'custom-textfield',
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid> */}

                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="BookNo"
                                    name="BookNo"
                                    label="Book No"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('BookNo') || ''}
                                    {...register('BookNo', { onChange: (e) => handleBookNoChange(e, 'A') })}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="BookDt"
                                    name="BookDt"
                                    label="Book Date"
                                    variant="filled"
                                    // type="date"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formatDate(watch('BookDt'))}
                                    {...register('BookDt')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="Duration"
                                    name="Duration"
                                    label="Duration"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('Duration') || ''}
                                    {...register('Duration')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="CheckinDt"
                                    name="CheckinDt"
                                    // type="date"
                                    label="Checkin Date"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formatDate(watch('CheckinDt'))}
                                    {...register('CheckinDt')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="BookUpToDt"
                                    name="BookUpToDt"
                                    label="Checkout Date"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formatDate(watch('BookUpToDt'))}
                                    {...register('BookUpToDt')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                    sx={{ backgroundColor: 'lightblue' }}
                                />
                            </Grid>


                        </Grid>
                        <hr></hr>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={2}>
                                <Typography variant="h6" gutterBottom >
                                    Room Details
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={10}>
                                <Grid container spacing={1} >
                                    <Grid item xs={6} md={2} sx={{ display: { xs: 'none', sm: 'flex', md: 'flex' } }}>
                                        <TextField
                                            id="WingName"
                                            name="WingName"
                                            label="Wing"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('WingName') || ''}
                                            {...register('WingName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={2} sx={{ display: { xs: 'none', sm: 'flex', md: 'flex' } }}>
                                        <TextField
                                            id="FloorName"
                                            name="FloorName"
                                            label="Floor"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('FloorName') || ''}
                                            {...register('FloorName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={2}>
                                        <TextField
                                            id="RoomTypeName"
                                            name="RoomTypeName"
                                            label="Room Type"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('RoomTypeName') || ''}
                                            {...register('RoomTypeName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={2}>
                                        <TextField
                                            id="RoombedName"
                                            name="RoombedName"
                                            label="Bed No"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('RoombedName') || ''}
                                            {...register('RoombedName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={2}>
                                        <TextField
                                            id="RoomBedTypeName"
                                            name="RoomBedTypeName"
                                            label="Bed Type"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('RoomBedTypeName') || ''}
                                            {...register('RoomBedTypeName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={2}>
                                        <TextField
                                            id="BedRent"
                                            name="BedRent"
                                            label="Standard Rent"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            {...register('BedRent')}
                                            value={watch('BedRent') || ''}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>
                                </Grid>
                                {/* </Paper> */}
                            </Grid>
                        </Grid>
                        <hr></hr>
                        <Grid container md={12} spacing={0.5}>
                            <Grid item xs={12} md={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={
                                            <>
                                                Request Date <span style={{ color: 'red' }}>*</span>
                                            </>
                                        }
                                        value={
                                            watch('ReqCheckoutDt')
                                                ? dayjs(watch('ReqCheckoutDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])
                                                : dayjs()
                                        }
                                        onChange={(newValue) => {
                                            if (newValue) {
                                                const formattedDate = newValue.format('DD/MM/YYYY');
                                                setValue('ReqCheckoutDt', formattedDate);
                                                setSelectedCheckoutDate(formattedDate);
                                            } else {
                                                setValue('ReqCheckoutDt', '');
                                                setSelectedCheckoutDate('');
                                            }
                                        }}
                                        minDate={dayjs(watch('CheckinDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])}

                                        format="DD/MM/YYYY"
                                        disabled={true}
                                        slotProps={{
                                            textField: {
                                                variant: 'filled',
                                                fullWidth: true,
                                                className: 'custom-textfield',
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Expected CheckOut Dt"
                                        value={
                                            watch('expectedcheckout')
                                                ? dayjs(watch('expectedcheckout'), 'DD/MM/YYYY')
                                                : dayjs()
                                        }
                                        onChange={(newValue) => {
                                            if (newValue) {
                                                const formattedDate = newValue.format('DD/MM/YYYY');
                                                setValue('expectedcheckout', formattedDate);
                                            } else {
                                                setValue('expectedcheckout', '');
                                            }
                                        }}
                                        format="DD/MM/YYYY"
                                        disabled={true}
                                        slotProps={{
                                            textField: {
                                                variant: 'filled',
                                                fullWidth: true,
                                                className: 'custom-textfield',
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>


                            <Grid item xs={12} md={2}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            id="IsCheckout"
                                            {...register('IsCheckout')}
                                            color="primary"
                                            defaultChecked
                                            disabled={true}
                                        />
                                    }
                                    label="Mark as Checkout"
                                />
                            </Grid>
                            <Grid item xs={12} md={1.5}>
                                <TextField
                                    id="PropName"
                                    name="PropName"
                                    label="Biil Cycle"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('BillCycle') === 'S' ? 'Second' : watch('BillCycle') === 'F' ? 'First' : watch('BillCycle') || ''}
                                    {...register('BillCycle')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={4.5}>
                                <TextField
                                    id="resion"
                                    name="resion"
                                    label="Reason for Checkout"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('Resion') || ''}
                                    {...register('Resion')}

                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} >
                            <Grid item xs={12} sm={12}>
                                <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                                    <Grid item xs={12} sm={6} md={6} display="flex" alignItems="center">
                                        <Typography variant="h6" gutterBottom sx={{ mr: 1 }}>
                                            Booking Status:
                                        </Typography>
                                        {TransactionData && TransactionData.length > 0 ? (
                                            <Typography
                                                component="span"
                                                style={{
                                                    color: TransactionData[0].BookSt === "C" ? "green" :
                                                        TransactionData[0].BookSt === "B" ? "blue" :
                                                            TransactionData[0].BookSt === "O" ? "orange" : "red",
                                                    fontWeight: "bold",
                                                    marginLeft: "8px"
                                                }}
                                            >
                                                {TransactionData[0].BookSt === "C"
                                                    ? "Confirmed"
                                                    : TransactionData[0].BookSt === "B"
                                                        ? "Booked"
                                                        : TransactionData[0].BookSt === "O"
                                                            ? "CheckedIn"
                                                            : TransactionData[0].BookSt === "L"
                                                                ? "CheckOut"
                                                                : TransactionData[0].BookSt === "X"
                                                                    ? "Cancelled"
                                                                    : "Unknown"}
                                            </Typography>
                                        ) : (
                                            <Typography variant="body1" sx={{ color: 'gray', fontWeight: 'bold' }}>
                                                Not Found
                                            </Typography>
                                        )}
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>

                    </Container>
                    <ConfirmationDialog
                        open={openCheckoutConfirm}
                        onClose={() => setOpenCheckoutConfirm(false)}
                        onConfirm={handleCheckoutConfirm}
                        title="Send Check-out Request Approved Email"
                        message="Are you sure you want to send checkout Request this booking?"
                    />
                    <ConfirmationDialog
                        open={openDeleteConfirm}
                        onClose={() => setOpenDeleteConfirm(false)}
                        onConfirm={handleDelete}
                        title="Delete Check-out Request"
                        message="Are you sure you want to delete this check-out request?"
                    />
                    {showPayAdvice && payAdvice.length > 0 && (
                        <Grid container sx={{ mt: 1 }}>
                            <Grid item xs={12}>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    sx={{
                                        mb: 1,
                                        fontSize: { xs: '0.85rem', sm: '0.95rem' },
                                        fontWeight: 'bold',
                                        color: '#1976d2',
                                        background: 'lightgray',
                                        padding: { xs: '6px 8px', sm: '8px 12px' },
                                        borderRadius: '4px',
                                        borderLeft: '4px solid #1976d2'
                                    }}
                                >
                                    💰 Payment Advice Details
                                </Typography>
                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        maxHeight: 200,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '8px',
                                        background: 'linear(145deg, #ffffff, #fafafa)',
                                        overflowX: 'auto'
                                    }}
                                >
                                    <Table
                                        stickyHeader
                                        size="small"
                                        sx={{
                                            minWidth: 650,
                                            '& .MuiTableCell-root': {
                                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                                border: '1px solid #e0e0e0',
                                                lineHeight: '1.2'
                                            },
                                            '& .MuiTableHead-root .MuiTableCell-root': {
                                                background: 'linear(45deg, #667eea 0%, #764ba2 100%)',
                                                color: 'white',
                                                fontWeight: 'bold',
                                                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                padding: { xs: '4px 6px', sm: '6px 8px' },
                                                borderBottom: '2px solid #5a6fd8',
                                                whiteSpace: 'nowrap'
                                            },
                                            '& .MuiTableBody-root .MuiTableCell-root': {
                                                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                                whiteSpace: 'nowrap'
                                            },
                                            '& .MuiTableRow-root': {
                                                height: { xs: '28px', sm: '32px' },
                                                cursor: 'pointer'
                                            }
                                        }}
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{
                                                    width: { xs: '12%', sm: '10%' },
                                                    background: '#d7dbd1ff !important',
                                                    color: 'black !important'
                                                }}>AdvNo</TableCell>
                                                <TableCell sx={{
                                                    width: { xs: '10%', sm: '8%' },
                                                    background: '#d7dbd1ff !important',
                                                    color: 'black !important'
                                                }}>AdvDt</TableCell>
                                                <TableCell sx={{
                                                    width: { xs: '12%', sm: '10%' },
                                                    background: '#d7dbd1ff !important',
                                                    color: 'black !important'
                                                }}>AdviceFor</TableCell>
                                                <TableCell sx={{
                                                    width: { xs: '10%', sm: '8%' },
                                                    background: '#d7dbd1ff !important',
                                                    color: 'black !important'
                                                }} align="right">AdvAmt</TableCell>
                                                <TableCell sx={{
                                                    width: { xs: '10%', sm: '8%' },
                                                    background: '#d7dbd1ff !important',
                                                    color: 'black !important'
                                                }} align="right">RcdAmt</TableCell>
                                                <TableCell sx={{
                                                    width: { xs: '10%', sm: '8%' },
                                                    background: '#d7dbd1ff !important',
                                                    color: 'black !important'
                                                }} align="right">Balance</TableCell>
                                                <TableCell sx={{
                                                    width: { xs: '10%', sm: '8%' },
                                                    background: '#d7dbd1ff !important',
                                                    color: 'black !important'
                                                }} align="center">DueDays</TableCell>
                                                <TableCell sx={{
                                                    width: { xs: '10%', sm: '8%' },
                                                    background: '#d7dbd1ff !important',
                                                    color: 'black !important'
                                                }}>RecDt</TableCell>
                                                <TableCell sx={{
                                                    width: { xs: '14%', sm: '12%' },
                                                    background: '#d7dbd1ff !important',
                                                    color: 'black !important'
                                                }}>Remark</TableCell>
                                                <TableCell sx={{
                                                    width: { xs: '22%', sm: '20%' },
                                                    background: '#d7dbd1ff !important',
                                                    color: 'black !important'
                                                }} align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {payAdvice?.map((item, index) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        height: { xs: '25px', sm: '28px' },
                                                        '&:nth-of-type(odd)': {
                                                            backgroundColor: '#f8fbff'
                                                        },
                                                        '&:nth-of-type(even)': {
                                                            backgroundColor: '#ffffff'
                                                        },
                                                        '&:hover': {
                                                            backgroundColor: '#f0f7ff'
                                                        }
                                                    }}
                                                    onDoubleClick={() => {
                                                        const url = `/advicegeneratetable?PytAdvId=${item.PytAdvId}`;
                                                        window.open(url, '_blank');
                                                    }}
                                                >
                                                    <TableCell sx={{
                                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                                        fontWeight: 'bold',
                                                        color: '#1565c0',
                                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                    }}>
                                                        {item?.PytAdvNo}
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                                        color: '#666',
                                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                    }}>
                                                        {moment(item?.PytAdvDt).format("DD-MM-YYYY")}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }}>
                                                        <Chip
                                                            label={
                                                                item?.PytAdvFor === "D" ? "Deposit" :
                                                                    item?.PytAdvFor === "R" ? "Rent" :
                                                                        item?.PytAdvFor === "O" ? "Other" :
                                                                            item?.PytAdvFor === "T" ? "TopUp" : ""
                                                            }
                                                            size="small"
                                                            sx={{
                                                                fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                                                height: { xs: '16px', sm: '18px' },
                                                                fontWeight: 'bold',
                                                                backgroundColor:
                                                                    item?.PytAdvFor === "D" ? '#e8f5e9' :
                                                                        item?.PytAdvFor === "R" ? '#fff3e0' :
                                                                            item?.PytAdvFor === "O" ? '#f3e5f5' :
                                                                                '#e1f5fe',
                                                                color:
                                                                    item?.PytAdvFor === "D" ? '#2e7d32' :
                                                                        item?.PytAdvFor === "R" ? '#ef6c00' :
                                                                            item?.PytAdvFor === "O" ? '#7b1fa2' :
                                                                                '#0277bd'
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                                        fontWeight: 'bold',
                                                        color: '#2e7d32',
                                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                    }} align="right">
                                                        ₹{item?.Amount}
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                                        fontWeight: 'bold',
                                                        color: '#1976d2',
                                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                    }} align="right">
                                                        ₹{item?.RcdAmt || '0'}
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                                        fontWeight: 'bold',
                                                        color: item?.BalAmount > 0 ? '#d32f2f' : '#2e7d32',
                                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                    }} align="right">
                                                        ₹{item?.BalAmount}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                                                        <Chip
                                                            label={item?.DueDays}
                                                            size="small"
                                                            sx={{
                                                                fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                                                height: { xs: '16px', sm: '18px' },
                                                                fontWeight: 'bold',
                                                                color: 'white',
                                                                backgroundColor:
                                                                    item?.DueDays === 0 ? '#4caf50' :
                                                                        item?.DueDays <= 7 ? '#ff9800' :
                                                                            item?.DueDays <= 30 ? '#f44336' :
                                                                                '#d32f2f'
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                                        color: '#666',
                                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                    }}>
                                                        {item?.RecDt ? moment(item.RecDt).format("DD-MM-YYYY") : "-"}
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                                        color: '#666',
                                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                    }}>
                                                        {item?.Remark || "-"}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                                                        {item?.PaymentSt && (
                                                            <Chip
                                                                label={item.PaymentSt}
                                                                size="small"
                                                                sx={{
                                                                    fontWeight: 'bold',
                                                                    color: 'white',
                                                                    backgroundColor:
                                                                        item.PaymentSt.toLowerCase() === 'paid' ? '#4CAF50' :
                                                                            item.PaymentSt.toLowerCase() === 'partial' ? '#FF9800' :
                                                                                '#F44336',
                                                                    marginRight: item.PaymentSt.toLowerCase() !== 'paid' ? '4px' : 0,
                                                                    fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                                                    height: { xs: '18px', sm: '20px' },
                                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                                                }}
                                                            />
                                                        )}
                                                        {item?.PaymentSt?.toLowerCase() !== 'paid' && (
                                                            <Box sx={{
                                                                display: 'inline-flex',
                                                                gap: 0.5,
                                                                ml: 0.5,
                                                                flexWrap: { xs: 'wrap', sm: 'nowrap' }
                                                            }}>
                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    color="primary"
                                                                    onClick={() => handleSendPaymentLink(item)}
                                                                    sx={{
                                                                        padding: { xs: '1px 6px', sm: '2px 8px' },
                                                                        minWidth: 'auto',
                                                                        fontSize: { xs: '0.55rem', sm: '0.6rem' },
                                                                        height: { xs: '20px', sm: '22px' },
                                                                        background: 'linear(45deg, #2196F3, #21CBF3)',
                                                                        boxShadow: '0 1px 3px rgba(33, 150, 243, 0.3)',
                                                                        '&:hover': {
                                                                            background: 'linear(45deg, #1976D2, #00B0FF)',
                                                                            boxShadow: '0 2px 5px rgba(33, 150, 243, 0.4)'
                                                                        }
                                                                    }}
                                                                >
                                                                    {loadingPaymentLinks[item.PytAdvId] ? (
                                                                        <CircularProgress size={10} sx={{ color: 'white' }} />
                                                                    ) : (
                                                                        '💳 Pay'
                                                                    )}
                                                                </Button>

                                                                <Tooltip title="Refresh Data" arrow>
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => fetchPayAdvice(BookId)}
                                                                        sx={{
                                                                            padding: '2px',
                                                                            '&:hover': {
                                                                                backgroundColor: 'rgba(255, 152, 0, 0.1)',
                                                                                transform: 'rotate(90deg)',
                                                                                transition: 'transform 0.3s ease'
                                                                            },
                                                                            height: { xs: '20px', sm: '22px' },
                                                                            width: { xs: '20px', sm: '22px' }
                                                                        }}
                                                                    >
                                                                        <RefreshIcon sx={{
                                                                            fontSize: { xs: '12px', sm: '14px' },
                                                                            color: '#FF9800',
                                                                            fontWeight: 'bold'
                                                                        }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Box>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    )}
                </Grid>

            </Box >
        </>
    )
}

export default CheckoutApprovel;